/* eslint-disable */
import React from "react";
import ScaleLoader from "react-spinners/ScaleLoader";

const Loader = props => {
    const { message } = props;
    return (
        <div className="sweet-loading">
            <ScaleLoader label={message} loading color="#333869" />
        </div>
    );
};
export default Loader;